import React from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'

import Root from './components/Root'
import history from './components/browserHistory'
import './stylesheets/index.js'
import './global.js'
import './i18n'

// Error monitoring (Sentry). A DSN is safe to ship in client code — it only
// permits sending events, not reading them. Overridable at build time via
// REACT_APP_SENTRY_DSN (build-time substitution, same pattern as the Maps/OAuth keys).
// The fallback is the `javascript-react` project in the `out-of-hand-theater` org.
// ⚠️ The trailing number is the PROJECT id, and a wrong one fails silently — Sentry
// drops the event at the edge, so a dead DSN looks exactly like "no errors".
const SENTRY_DSN =
  process.env.REACT_APP_SENTRY_DSN ||
  'https://2d8ce133b1059177dc8aa95e37342fbb@o4511869780295680.ingest.us.sentry.io/4511869816537088'

// Reporting is gated on the environment, mirroring the Rails side's
// `config.enabled_environments`. The default is `development` on purpose: the DSN
// above always falls back to a literal, so it is never empty and an ungated init
// would report from `npm start` on a laptop. A build reports only once its
// REACT_APP_SENTRY_ENV says which deployed environment it is.
const SENTRY_ENV = process.env.REACT_APP_SENTRY_ENV || 'development'

if (SENTRY_DSN && SENTRY_ENV !== 'development') {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENV,
    // Error monitoring only for now — no performance tracing or session replay.
    tracesSampleRate: 0,
  })
}

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element not found. Ensure there is a <div id="root"> in your index.html.')
}

const root = createRoot(rootElement)
root.render(<Root history={history} />)
